import gql from 'graphql-tag';

import { LoyaltyCustomerFragment } from './fragments';

export const GetPartnerLinkStatus = gql`
  query partnerLinkStatus($customerId: String!, $partnerId: String!) {
    partnerLink(customerId: $customerId, partnerId: $partnerId) {
      status
    }
  }
`;

export const GetPartnerLinksByCustomerId = gql`
  query getPartnerLinksByCustomerId($customerId: String!, $partnerId: String!) {
    loyaltyByCustomerId(customerId: $customerId) {
      customer {
        ...LoyaltyCustomerFragment
      }
    }
    partnerLink(customerId: $customerId, partnerId: $partnerId) {
      partnerId
      partnerName
      status
      thLinkId
      partnerLinkId
      linkedAt
      delinkedAt
      linkSource
      delinkSource
      hostTransactionId
      rateLimited
      rateLimitRemaining
      retryAfter
      eventCount
      events {
        eventTimestamp
        status
        source
        thLinkId
        partnerLinkId
        hostTransactionId
      }
    }
  }
  ${LoyaltyCustomerFragment}
`;

export const DelinkPartner = gql`
  mutation delinkPartner($input: DelinkPartnerInput!) {
    delinkPartner(input: $input) {
      success
      delinkedAt
      thLinkId
      partnerLinkId
    }
  }
`;
